import { IconLayoutSidebarLeftCollapse, IconLayoutSidebarLeftExpand } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { ReportingClock } from "@/components/patterns/reporting-time-zone-select";
import { useAnimatedSidebar } from "@/components/ui/animated-sidebar";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useReportingTimeZoneStore } from "@/stores/reporting-time-zone";

export function SiteHeader(): React.ReactElement {
  const timeZone = useReportingTimeZoneStore((state) => state.timeZone);
  return (
    <header className="flex h-[68px] shrink-0 items-center justify-between gap-4 border-b border-line pr-5 pl-3">
      <SidebarToggle />
      <ReportingClock value={timeZone} />
    </header>
  );
}

export function SidebarToggle(): React.ReactElement {
  const { t } = useTranslation("layout");
  const { expanded, toggle } = useAnimatedSidebar();
  const label = expanded ? t("nav.collapseSidebar") : t("nav.expandSidebar");

  return (
    <Tooltip>
      <TooltipTrigger
        aria-label={label}
        render={<button type="button" onClick={toggle} />}
        className="hidden size-8 shrink-0 items-center justify-center rounded-[8px] text-muted-foreground outline-none transition-colors hover:bg-subtle hover:text-ink focus-visible:ring-2 focus-visible:ring-ring md:flex"
      >
        {expanded ? (
          <IconLayoutSidebarLeftCollapse className="size-4" stroke={1.75} aria-hidden />
        ) : (
          <IconLayoutSidebarLeftExpand className="size-4" stroke={1.75} aria-hidden />
        )}
      </TooltipTrigger>
      <TooltipContent side="bottom">
        {label} · {t("nav.shortcut")}
      </TooltipContent>
    </Tooltip>
  );
}
